module.exports = __webpack_public_path__ + "img/a2_b2_result.16a28aec.png";